<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="'600px'"
  (nzOnCancel)="onEmitClose(false)"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img loading="lazy" [src]="'./assets/images/' + (isSubscribe ? 'subscribe.jpg' : 'update.jpg')" alt="" style="height: 220px;">
      <p class="text-info mt-xlg text-center text-upper-case">
        {{ isSubscribe ? 'Vas a contratar de nuevo una suscripción' : 'Estás a punto de cambiar de plan.' }}
      </p>
      <div class="tw-w-full mt-xlg tw-flex tw-flex-col md:tw-flex-row justify-content-center align-items-center">
        <div class="d-flex plan-item" *ngIf="!isSubscribe">
          <img loading="lazy" class="icon-plan mr-xxs" [src]="'./assets/images/icons/' + currentPlan.product.metadata.image" alt="">
          <div>
            <p class="text-info mb-xxs truncate">{{ currentPlan.product.name }}</p>
            <p class="text-info-bold truncate">${{ currentPlan.amount }} <span class="text-info-bold-xs">{{ currentPlan.currency }}</span> / {{
              currentPlan.interval === 'year' ? 'Año' : 'Mes' }}</p>
          </div>
        </div>

        <i *ngIf="!isSubscribe" nz-icon nzType="arrow-right" nzTheme="outline" class="icon-arrow" style="font-size: 16px;"></i>

        <div class="d-flex plan-item">
          <img loading="lazy" class="icon-plan mr-xxs" [src]="'./assets/images/icons/' + newPlan.product.metadata.image" alt="">
          <div>
            <p class="text-info mb-xxs truncate">{{ newPlan.product.name }}</p>
            <p class="text-info-bold truncate">${{ newPlan.amount }} <span class="text-info-bold-xs">{{ newPlan.currency }}</span> / {{
              newPlan.interval === 'year' ? 'Año' : 'Mes' }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal d-flex justify-content-center" [@fadeInAnimation]>
      <button
        (click)="onEmitClose(false)"
        class="btn-default"
        nz-button nzType="default">
        NO QUIERO</button>
      <button
        (click)="onEmitClose(true)"
        nz-button nzType="primary">
        SÍ QUIERO {{ isSubscribe ? 'SUSCRIBIRME' : 'ACTUALIZAR' }}</button>
    </div>
  </ng-template>
</nz-modal>
